import dictData from './dictData'
// 字典集合
const dicts = dictData
/**
 * 数据字典
 *
 * 根据字典名称和值获取标签
 * @param {string} dictName 字典名称
 * @param {string|number} value 要查找的值
 * @param {string} defaultLabel 默认标签（可选）
 * @returns {string} 对应的标签文本
 */
export const getDictLabel = (dictName, value, defaultLabel = '-') =>{
  const dict = dicts[dictName];
  if (!dict) {
    console.warn(`字典"${dictName}"不存在`);
    return defaultLabel || value;
  }

  const item = dict.find(item => item.value == value);
  return item ? item.label : (defaultLabel || value);
}

/**
 * 获取整个字典数组
 * @param {string} dictName 字典名称
 * @returns {Array} 字典数组
 */
export const getDict = (dictName) => {
  return dicts[dictName] || [];
}
/**
 * 获取所有字典
 * @returns {Object} 所有字典对象
 */
export const getAllDicts = () => {
  return dicts;
}

export default {
  getDictLabel,
  getDict,
  getAllDicts
}
